import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ChangeDetectorRef
} from '@angular/core';
import { PtgInterface } from '../../../model/ptgs/ptg-interface';

import { PtgVersionInterface } from '../../../model/ptgs/ptg-version-interface';
import { VariantVersionInterface } from '../../../model/products/variant-version-interface';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { PtgService } from 'src/app/services/dataServices/ptg-service/ptgService';
import { AttributeValidationServiceService } from 'src/app/services/dataServices/dataValidation/attribute-validation-service/attribute-validation-service.service';
import { CertificationVariantVersionInterface } from 'src/app/model/certifications/certification-variant-version-interface';
import { CertificationService } from 'src/app/services/dataServices/certification-service/certificationService';
import { SortMethod } from 'src/app/model/enums/SortMethod';
import { PtgPageInterface } from 'src/app/model/ptgs/ptg-page-interface';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-add-ptg-dependency-panel',
    templateUrl: './add-ptg-dependency-panel.component.html',
    styleUrls: ['./add-ptg-dependency-panel.component.scss'],
    standalone: false
})
export class AddPtgDependencyPanelComponent implements OnInit {
    @Input()
    version: VariantVersionInterface | CertificationVariantVersionInterface;

    @Input()
    isCertification?: boolean;

    @Output()
    addedPtgVersion = new EventEmitter<PtgVersionInterface>();

    public addPtgDependencyMode: boolean = false;
    public ptgWithActiveVersions: PtgPageInterface;
    public totalNumberOfElements: number;
    public pageIndex: number = 0;

    constructor(
        public ptgService: PtgService,
        public productService: ProductService,
        public certificationService: CertificationService,
        private cd: ChangeDetectorRef,
        private attributeValidationService: AttributeValidationServiceService
    ) { }

    onToggle(isAddPTGDependencyMode: boolean) {
        this.addPtgDependencyMode = isAddPTGDependencyMode;
        if (this.addPtgDependencyMode && !this.cd['destroyed']) {
            this.cd.detectChanges();
        }
    }

    pageChanged(event: PageEvent): void {
        this.pageIndex = event.pageIndex * 5;
        this.loadPTGPage();
    }

    private loadPTGPage(): void {
        this.ptgService
            .getPtgSliceActVer(
                this.pageIndex,
                5,
                '',
                SortMethod.ALPHABETICAL_ASC
            )
            .subscribe((ptgArray: PtgPageInterface) => {
                this.ptgWithActiveVersions = ptgArray;
                this.cd.detectChanges();
            });
    }

    addPtgVersion(ptg: PtgInterface): void {
        const newVersion: PtgVersionInterface = ptg.versions[0];
        const containsSelectedVersion = this.version.ptgVersions.some(
            (version) => {
                return version.id == newVersion.id;
            }
        );
        if (containsSelectedVersion) {
            return;
        }

        this.version.ptgVersions.push(newVersion);
        this.version.ptgVersionIds.push(newVersion.id);
        newVersion.attributeValidations.forEach((attributeValidation) => {
            const attribute = attributeValidation.attribute;
            if (
                !this.attributeValidationService.activeEntityFeatureValues.has(
                    attribute.id
                )
            ) {
                this.attributeValidationService.activeEntityFeatureValues.set(
                    attribute.id,
                    null
                );
            }
        });
        this.addedPtgVersion.emit(newVersion);
    }

    ngOnInit(): void {
        this.loadPTGPage();
    }
}
